import {useEffect, useMemo, useRef, useState} from "react";
import useTiming from "./useTiming";
import {useRecoilValue} from "recoil";
import {firebaseClaimsState, firebaseSessionIdState, firebaseUidState, firebaseUserState} from "../state/firebaseState";
import firebaseApp from "../services/firebase";
import firebase from "firebase";

export const useActiveQuestion = () => {
  const timing = useTiming()
  const firebaseUid = useRecoilValue(firebaseUidState);
  const [activeQuestion, setActiveQuestion] = useState(null);
  const activeTimers = useRef([]);

  useEffect(() => {
    if(!timing?.id || !firebaseUid) {
      return;
    }

    const ref = firebaseApp.database().ref(`room-messages/${timing?.id}`)
    .orderByChild('type')
    .equalTo('question');

    const cb = (snapshot) => {
      const questions = [];

      snapshot.forEach(item => {
        questions.push({
          id: item.key,
          ...item.val(),
        })
      });

      questions.sort((a, b) => b.timestamp - a.timestamp);

      setActiveQuestion(questions.find(i => !i.deletedBy && i.question.layout !== 'inline'));
    };
    ref.on('value', cb);

    return () => {
      ref.off('value', cb);
    }
  }, [timing?.id, firebaseUid]);

  return activeQuestion;
};

export const useQuestionSecondsLeft = (item) => {
  const [secondsLeft, setSecondsLeft] = useState(item.question.duration);

  useEffect(() => {
    if(!item) {
      return;
    }

    let intervalId = null;

    const refreshSeconds = () => {
      const seconds = Math.ceil((item.timestamp + (item.question.duration * 1000) - (+new Date())) / 1000);

      if (seconds < 0 && intervalId) {
        clearInterval(intervalId);
      }

      setSecondsLeft(Math.max(0, seconds));

      return seconds;
    }

    if (refreshSeconds() > 0) {
      intervalId = setInterval(refreshSeconds, 1000);
    }

    return () => {
      clearInterval(intervalId);
    }
  }, [item?.id, item.timestamp, item.question.duration]);

  return secondsLeft;
}

export const useQuestionHasAnswered = (item) => {
  const timing = useTiming()
  const firebaseUid = useRecoilValue(firebaseUidState);

  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setValue(null);
    setLoading(true);

    if(!timing?.id || !firebaseUid || !item?.question?.id) {
      setLoading(false);
      return;
    }

    const cb = (snapshot) => {
      setValue(snapshot.val()?.value);
      setLoading(false);
    };

    const ref = firebaseApp.database()
    .ref(`room-question-entries/${timing?.id}/${item?.question?.id}/${firebaseUid}`);

    ref.on('value', cb)

    return () => {
      ref.off('value', cb);
    }
  }, [timing?.id, firebaseUid, item?.question?.id]);

  const setAnswer = useMemo(() => (answer) => {
    if(!timing?.id || !firebaseUid || !item?.question?.id || value) {
      return;
    }

    setLoading(true);

    firebaseApp.database()
    .ref(`room-question-entries/${timing?.id}/${item.question?.id}/${firebaseUid}`)
    .set({
      value: answer,
      timestamp: firebase.database.ServerValue.TIMESTAMP,
    })
    .then((val) => {
      setValue(answer);
      setLoading(false);
    })
    .catch(() => {
      setLoading(false);
    })
  }, [timing?.id, firebaseUid, item?.question?.id, value]);

  return {
    loading,
    value,
    setAnswer,
  }
}
